const faqs = [
    { 
        id: 1, 
        heading: 'How do I rent a car?',
        content: 'Renting a car is simple! You can book online through our website, visit our rental office, or call our customer service. Just select your vehicle, choose your rental duration, and confirm your booking.',
    }, 
    {
        id: 2,
        heading: 'What payment methods do you accept?',
        content: 'We accept major credit/debit cards, online payments, and cash. A security deposit may be required depending on the rental agreement.',
    },
    { 
        id: 3,
        heading: 'What is your cancellation policy?',
        content: 'You can cancel your booking for free up to 24 hours before the pickup time. Late cancellations may incur a fee based on the rental terms.',
    },
    {
        id: 4,
        heading: 'Does the rental include insurance?',
        content: 'Yes, our rental cars include basic insurance coverage. You can also opt for additional protection plans for extra peace of mind.',
    },
];

export default faqs;